<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()">
  </button>
</div>
<div class="modal-body">
{{ message }}
</div>
<div class="modal-footer">
  @if(btnCancelText!== null &&  btnCancelText !== ''){
<button type="button" class="btn btn-secondary"
    (click)="decline()"><i class="fas fa-close"></i> {{ btnCancelText }} </button>
  }
  @if(btnOkText!== null &&  btnOkText !== ''){
 <button type="button" class="btn btn-envio" (click)="accept()"><i
      class="fas fa-check"></i> {{ btnOkText }} </button>
  } 
</div>